<template>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Oleo+Script&display=swap" rel="stylesheet">
  <WSCalc/>
</template>

<script>
import WSCalc from './components/WSCalc.vue'

export default {
  name: 'App',
  components: {
    WSCalc
  }
}
</script>

<style>
body {
  width: 100%;
  margin: 0;
  border: 0;
  background-image: url("assets/coins.jpg");
  background-size: cover;
}

#app {
  font-family: "Oleo Script", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: auto;
  margin-top: 20px;
}
</style>
